import { getTestIds } from 'seagull/utils/TestIds';
export const addToAnotherClientModalTextsPath = 'client.addToAnotherClientModal';
const normalizedEmail = (contact)=>contact.email().trim().toLowerCase();
const isSameContact = (first, second)=>{
    const firstUserId = first.userId();
    const secondUserId = second.userId();
    if (firstUserId != null && secondUserId != null && firstUserId === secondUserId) {
        return true;
    }
    return normalizedEmail(first) === normalizedEmail(second);
};
export const getAssociableClients = (param)=>{
    let { clients, contacts, contact } = param;
    const associatedClientIds = new Set(contacts.filter((candidate)=>isSameContact(candidate, contact)).map((candidate)=>candidate.customerId()).filter((customerId)=>customerId != null));
    return clients.filter((client)=>!client.isSample() && !client.isMultiVendorCustomer() && !associatedClientIds.has(client.clientId())).map((client)=>({
            clientId: client.clientId(),
            name: client.name()
        })).sort((first, second)=>first.name.localeCompare(second.name));
};
export const GetAddToAnotherClientModalTID = (parentTestId)=>getTestIds(parentTestId);
